module.exports = __webpack_public_path__ + "assets/MaterialIcons-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./~/material-icons/iconfont/MaterialIcons-Regular.woff
// module id = 951
// module chunks = 1